import CryptoJS from 'crypto-js';
import { supabase } from '../supabaseClient';

const getEncryptionKey = async () => {
    if (!supabase) return null;
    const { data: { user } } = await supabase.auth.getUser();
    if (user?.user_metadata?.encryption_key) {
        return user.user_metadata.encryption_key;
    }
    const key = CryptoJS.lib.WordArray.random(32).toString();
    await supabase.auth.updateUser({ data: { encryption_key: key } });
    return key;
};

export const encrypt = async plaintext => {
    const key = await getEncryptionKey();
    if (!key) return plaintext;
    return CryptoJS.AES.encrypt(plaintext, key).toString();
};

export const decrypt = async ciphertext => {
    const key = await getEncryptionKey();
    if (!key) return ciphertext;
    const bytes = CryptoJS.AES.decrypt(ciphertext, key);
    const result = bytes.toString(CryptoJS.enc.Utf8);
    if (!result) throw new Error('Decryption failed — key may have changed');
    return result;
};
